import { useTranslations } from 'use-intl';

const fallbackTranslations: Record<string, string> = {
  'error.maintenance_title': "We're working on it",
  'error.maintenance_desc':
    'Our team is currently performing maintenance to improve your experience. Please try again in a few minutes.',
};

export default function MaintenanceError() {
  // Try to get translations, but fallback to hardcoded text if intl context is not available
  const t = useTranslations();
  const getTranslation = (key: string) => {
    const translated = t(key);
    if (translated === key) {
      return fallbackTranslations[key] || key;
    }
    return translated;
  };

  return (
    <div className="flex flex-col justify-center items-center h-svh bg-brand-50">
      <div className="flex flex-col gap-2 justify-center items-center m-auto w-full h-full">
        <img src="/assets/logo.svg" alt="Logo" className="mb-4 w-20 h-20" />
        <span className="text-[72px] font-semibold text-brand-700 leading-tight">Hang on!</span>
        <span className="text-[72px] font-semibold text-gray-900">{getTranslation('error.maintenance_title')}</span>
        <p
          className="text-lg text-center text-gray-900"
          dangerouslySetInnerHTML={{ __html: getTranslation('error.maintenance_desc') }}
        />
      </div>
    </div>
  );
}
